import { useEffect, useState } from "react";
import axios from "axios";
import ListingCard from "../components/ListingCard";
import SearchContainer from "../components/SearchContainer";



export default function Home(){
    let [insertions, setInsertions] = useState([]);

    useEffect(() => {
        axios.get("http://109.230.235.211/api/get-ad").then( (res) => {
            setInsertions(res.data.insertions);
        });
    },[]);

    return (
        <>
            <div class="ltn__slider-area ltn__slider-3  section-bg-2">
                <div class="ltn__slide-one-active slick-slide-arrow-1 slick-slide-dots-1">
                
                    <div class="ltn__slide-item ltn__slide-item-2 ltn__slide-item-3-normal--- ltn__slide-item-3 bg-image bg-overlay-theme-black-60" data-bs-bg="img/slider/slider-main.jpg">
                        <div class="ltn__slide-item-inner text-center">
                            <div class="container">
                                <div class="row">
                                    <div class="col-lg-12 align-self-center">
                                        <div class="slide-item-info">
                                            <div class="slide-item-info-inner ltn__slide-animation">
                                               
                                                <h6 class="slide-sub-title white-color--- animated"><span><i class="fas fa-home"></i></span> AD Servizi Immobiliari</h6>
                                                <h1 class="animated ">Ti aiutiamo a realizzare i tuoi sogni</h1>
                                                <div class="slide-brief animated">
                                                    <p>Cerchi o vendi casa? Scopri il modo più vantaggioso di sempre.</p>
                                                </div>
                                                <div class="btn-wrapper animated">
                                                    <a href="/ricerca" class="theme-btn-1 btn btn-effect-1">Esplora</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                    
                </div>
            </div>
  
            <SearchContainer/>

            <div class="ltn__feature-area section-bg-1--- pt-115 pb-90 mb-120---">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="section-title-area ltn__section-title-2--- text-center">
                                <h6 class="section-subtitle section-subtitle-2 ltn__secondary-color">Servizi</h6>
                                <h1 class="section-title">Da dove vuoi partire?</h1>
                            </div>
                        </div>
                    </div>
                    <div class="row ltn__custom-gutter---  justify-content-center">
                        <div class="col-lg-4 col-sm-6 col-12">
                            <div class="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                                <div class="ltn__feature-icon">
                                    
                                    <img src="img/icons/icon-img/21.png" alt="#"/>
                                </div>
                                <div class="ltn__feature-info">
                                    <h3><a href="">Compra</a></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam justo purus, viverra non maximus quis, hendrerit varius nulla.</p>
                                    <a class="ltn__service-btn" href="">Continua a leggere <i class="flaticon-right-arrow"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-12">
                            <div class="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1 active">
                                <div class="ltn__feature-icon">
                                    
                                    <img src="img/icons/icon-img/22.png" alt="#"/>
                                </div>
                                <div class="ltn__feature-info">
                                    <h3><a href="">Affitta</a></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam justo purus, viverra non maximus quis, hendrerit varius nulla.</p>
                                    <a class="ltn__service-btn" href="">Continua a leggere <i class="flaticon-right-arrow"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-12">
                            <div class="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                                <div class="ltn__feature-icon">
                                    
                                    <img src="img/icons/icon-img/23.png" alt="#"/>
                                </div>
                                <div class="ltn__feature-info">
                                    <h3><a href="">Vendi</a></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam justo purus, viverra non maximus quis, hendrerit varius nulla.</p>
                                    <a class="ltn__service-btn" href="">Continua a leggere <i class="flaticon-right-arrow"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
            
            <div class="ltn__product-slider-area ltn__product-gutter pt-115 pb-90">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="section-title-area ltn__section-title-2--- text-center">
                                <h6 class="section-subtitle section-subtitle-2 ltn__secondary-color">Proprietà</h6>
                                <h1 class="section-title">Ultime inserzioni</h1>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="row">
                            {
                                insertions.map( (data) => {
                                    return <ListingCard info={data}/>;
                                })
                            }
                        </div>
                        
                    </div>
                </div>
            </div>
            


            <div class="ltn__call-to-action-area call-to-action-6 before-bg-bottom" data-bs-bg="img/1.jpg--">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="call-to-action-inner call-to-action-inner-6 ltn__secondary-bg position-relative text-center---">
                                <div class="coll-to-info text-color-white">
                                    <h1>Stai cercando la casa dei tuoi sogni?</h1>
                                    <p>Ti possiamo aiutare a realizzare il tuo sogno!</p>
                                </div>
                                <div class="btn-wrapper">
                                    <a class="btn btn-effect-3 btn-white" href="/ricerca">Esplora i nostri annunci <i class="icon-next"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}